<template src="./assetoverview.html"></template>
<script>
import { mapState } from "vuex";
import Axios from "axios";
import UpcomingEvent from "@/pages/upcomingevent/upcomingevent";
import Task from "@/pages/task/task";
export default {
  components: {
    UpcomingEvent,
    Task,
  },
  props: {
    RequestFor: String,
    Title: String,
    todaysUrgentTaskNew: Boolean,
  },
  data() {
    return {
      UpcomingEvent: {},
      DashboardData: {},
      DashboardReport: {},
      DashboardReportData: {},
      CalenderEvent: [],
      OtherData: [],
      excel_data: [],
      excel_title: "",
      VehicleWarningCnt: 0,
      ShowDashboardReportDetailLoader: false,
    };
  },
  mounted() {
    this.GetDashBoardReport();
    //this.GetUpcomingEventList();
  },
  methods: {
    exportActionNeeded() {
      this.$refs.upcoming_events2.exportActionNeeded();
    },
    exportUrgentTask() {
      this.$refs.urgent_task.exportActionNeeded();
    },
    GetDashBoardReport() {
      var Type = "assets";     
      Axios.post(Endpoints.Dashboard.DashboardReport, {
        token: localStorage.getItem("token"),
        type: Type,
        item_type: this.RequestFor,
      }).then((Response) => {
        if (Response.data.success) {
          this.DashboardReport = Response.data.DashboardReport;
        }
      });
    },
    ShowDashboardReportDetail(type) {
      this.ShowDashboardReportDetailLoader = true;
      Axios.post(Endpoints.Dashboard.DashboardReportData, {
        token: localStorage.getItem("token"),
        type: type,
        item_type: this.RequestFor,
      }).then((Response) => {
        this.ShowDashboardReportDetailLoader = false;
        if (Response.data.success) {
          this.DashboardReportData = Response.data.DashboardReportData;
          this.excel_data = [];          
          if (type == "safe") {
          	this.DashboardReportData.AssetSafeArr = this.DashboardReportData.AssetSafeArr
            if (this.DashboardReportData.AssetSafeArr.length > 0) {
              this.DashboardReportData.AssetSafeArr.forEach((element) => {
                var obj = {};
                obj["Asset"] = element.vrm;
                obj["Make/Model"] = element.make+' '+element.model;                                                
                this.excel_data.push(obj);
              });
            }
            this.excel_title = "safe-asset-list";
          }
          if (type == "unsafe") {
          	this.DashboardReportData.AssetUnSafeArr = this.DashboardReportData.AssetUnSafeArr
            if (this.DashboardReportData.AssetUnSafeArr.length > 0) {
              this.DashboardReportData.AssetUnSafeArr.forEach((element) => {
                var obj = {};
                obj["Asset"] = element.vrm;
                obj["Make/Model"] = element.make+' '+element.model;
                obj["Reason"] = element.unsafe_reason;
                this.excel_data.push(obj);
              });
            }
            this.excel_title = "unsafe-asset-list";
          }
          if (type == "warning") {
          	this.DashboardReportData.AssetWarningArr = this.DashboardReportData.AssetWarningArr
            if (this.DashboardReportData.AssetWarningArr.length > 0) {
              this.DashboardReportData.AssetWarningArr.forEach((element) => {
                var obj = {};
                obj["Asset"] = element.vrm;
                obj["Make/Model"] = element.make+' '+element.model;
                obj["Reason"] = element.unsafe_reason;
                this.excel_data.push(obj);
              });
            }
            this.excel_title = "asset-warning-list";
          }
        }
      });
    },
    GetUpcomingEventList() {
      Axios.post(Endpoints.Dashboard.UpcomingEvent, {
        token: localStorage.getItem("token"),
        RequestFor: this.RequestFor,
      }).then((Response) => {
        if (Response.data.success) {
          this.UpcomingEvent = Response.data.upcoming_event;
          this.CalenderEvent = Response.data.calender_event;
          this.OtherData = Response.data.other_data;
          var ActionsNeededCount = 0;
          this.CalenderEvent.forEach((element, index) => {
            if (element.status == "red") {
              ActionsNeededCount++;
            }
            if (element.status == "yellow") {
              ActionsNeededCount++;
            }
          });
          if (document.getElementById("ActionsNeededCount")) {
            document.getElementById("ActionsNeededCount").innerHTML = ActionsNeededCount;
            if (this.OtherData.redStatusCnt >= 1) {
              document.getElementsByClassName("urgent-task-btn")[0].innerHTML =
                this.OtherData.redStatusCnt + " Urgent Tasks Required";
              document.getElementsByClassName("urgent-task-btn")[0].style.display = "block";
            } else {
              document.getElementsByClassName("urgent-task-btn")[0].style.display = "none";
            }
          }
        }        
      });
    },
   
  },
};
</script>
<style scoped>
.btn.vehicle-task-required {
  position: absolute;
  right: 10px;
  top: 3px;
  font-size: 9px !important;
}
.display-inline {
  display: inline-block !important;
}
.modal-footer {
  text-align: right !important;
}
</style>
